import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export const SuccessPage = () => {
  return <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-905">
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      duration: 0.5,
      type: 'spring',
      stiffness: 200
    }} className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mb-6" data-id="element-906">
        <CheckIcon className="h-12 w-12 text-white" data-id="element-907" />
      </motion.div>
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.5
    }} className="text-4xl font-bold text-[#0B1220]" data-id="element-908">
        Success!
      </motion.h1>
    </div>;
};